import compressor from "browser-image-compression";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { useAuthStore } from "@/stores/auth.store";
import { useDriverDutyStore } from "@/stores/driver-duty.store";
import { useOrderStore } from "@/stores/order.store";
import { useUserStore } from "@/stores/user.store";

import client from "./client";
dayjs.extend(utc);
export const getDriverShiftSchedule = async () => {
	const driverDutyStore = useDriverDutyStore();
	const orderStore = useOrderStore();
	const today = dayjs().utc().format();
	try {
		const response = await (
			await client
		)?.getShiftSchedule({
			dateTime: today,
		});
		if (response?.shift_schedule.length === 0) {
			driverDutyStore.setShiftSchedule(null);
			orderStore.setUpcomingTasks([]);
			return null;
		}

		driverDutyStore.setShiftSchedule(response?.shift_schedule[0]);

		return response?.shift_schedule[0];
	} catch (err) {
		console.error(err);
		throw new Error("Error fetching driver shift schedule");
	}
};

export const getUserDetails = async (uid?: string) => {
	const authStore = useAuthStore();
	const userStore = useUserStore();
	try {
		const response = await (
			await client
		)?.getUser({
			firebaseID: uid || authStore.user?.uid,
		});
		userStore.setUserData(response?.user[0]);
	} catch (error) {
		throw error;
	}
};

const uploadFile = async (
	fileName: string,
	contentType: string,
	file: File,
) => {
	try {
		const { uploadFile } = await (
			await client
		).uploadFileToBucket({
			file: {
				bucketName: import.meta.env.VITE_FB_BUCKET,
				fileName: `${Date.now()}`,
				contentType,
			},
		});

		// safe gaurd check for signedUrl
		if (!uploadFile?.signedUrl) {
			throw new Error("Signed URL is missing");
		}

		const compressedFile = await compressor(file, {
			maxSizeMB: 0.5,
			maxWidthOrHeight: 1024,
			useWebWorker: true,
		});
		const response = await fetch(uploadFile?.signedUrl, {
			method: "PUT",
			headers: {
				"Content-Type": contentType,
			},
			body: compressedFile,
		});

		if (!response.ok) {
			// Handle error manually
			throw new Error(`Upload failed with status ${response.status}`);
		}
		const src = await fetchFile(uploadFile?.storeUrl);
		return { src: src, storeUrl: uploadFile?.storeUrl };
	} catch (err) {
		alert("Please upload image again");
		throw new Error("Error uploading img", { cause: err });
	}
};

const fetchFile = async (url: string | null | undefined) => {
	try {
		const response = await (
			await client
		).fetchFileUrlFromServer({ file: { fileUrl: url as string } });
		return response.fetchFile?.url;
	} catch (err) {
		alert("Please upload image again");
		throw new Error("error fetching file from server", {
			cause: err,
		});
	}
};

export const uploadImage = async (file: File) => {
	try {
		// loaderStore.toggleLoader({ type: "image", state: true });
		const url = await uploadFile(file.name, file.type, file);
		return url;
	} catch (_err) {
		alert("Error uploading file.");
		throw new Error("Error uploading to bucket");
	}
};
